import type { ReactElement } from 'react';
import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useAccordion } from 'atom-components/accordion/accordion';
import useIsOverflow from 'hooks/useIsOverflow';
import styles from './index.module.scss';

export default function ReportFiltersSidebar({ children }: React.PropsWithChildren): ReactElement {
  const cardBody = useRef(null);
  const isOverflowing = useIsOverflow(cardBody);

  const [buttonProps, contentProps, { isOpen }] = useAccordion({ initialOpen: true });

  return (
    <div className={styles.reportSidebarWrapper}>
      <div
        ref={cardBody}
        className={clsx(styles.reportSidebar, 'card m-2 d-print-none', {
          'w-auto': !isOpen,
          [styles.overflowing]: isOverflowing
        })}
        style={{ width: 250, minWidth: isOpen ? 250 : undefined }}
      >
        <button
          type="button"
          id={buttonProps.id}
          onClick={buttonProps.onClick}
          aria-expanded={buttonProps['aria-expanded']}
          aria-controls={buttonProps['aria-controls']}
          className="card-header p-3 btn d-flex justify-content-between align-items-center cursor-pointer w-100"
        >
          <span className={clsx('h5', { 'visually-hidden': !isOpen })}>Filters</span>
          <FontAwesomeIcon
            icon="angles-right"
            className="m-2"
            flip={!isOpen ? 'horizontal' : undefined}
          />
        </button>
        {isOpen && (
          <div {...contentProps} className="card-body p-3">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
